export const DOWNLOAD_ACTION_DEFAULT_LABEL = 'Descargar'
export const DOWNLOAD_ACTION_DEFAULT_CSV_LABEL = 'Vista detallada (.csv)'
export const DOWNLOAD_ACTION_DEFAULT_PDF_LABEL = 'Vista resumida (.pdf)'
